import { HowToCompareSection } from "./view";
export default HowToCompareSection;
